const SERVICES = [
  {
    key: "hardware",
    badge: "Hırdavat",
    title: "Hırdavat Malzemeleri",
    desc:
      "El aletinden cıvata-somuna, yapı gereçlerinden elektrik-tesisat sarflarına kadar geniş ürün yelpazesiyle esnafın ve ev kullanıcısının ihtiyacını karşılıyoruz.",
    items: [],
    img: "https://images.unsplash.com/photo-1581147036324-c47a03a81d48?auto=format&fit=crop&w=1400&q=80",
    accent: "var(--tt-green-700)",
  },
  {
    key: "recycle",
    badge: "Geri Dönüşüm",
    title: "Hurda & Geri Dönüşüm",
    desc:
      "Demir, bakır, alüminyum, pirinç, kurşun ve diğer metallerin alımını yapıyor; doğa dostu, vicdanlı ve düzenli bir süreçle değerlendiriyoruz.",
    items: [
      "Demir & çelik hurda alımı",
      "Bakır, pirinç, alüminyum",
      "Kablo, motor, transformatör",
      "Endüstriyel tesis sökümü",
      "Düzenli tartı & açık fiyat",
      "Adrese servis (talebe göre)",
    ],
    img: "https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?auto=format&fit=crop&w=1400&q=80",
    accent: "var(--tt-orange)",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-[var(--tt-cream-dark)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-[var(--tt-orange)]">
              Hizmetlerimiz
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--tt-green-900)] mt-4 leading-[1.02] max-w-2xl">
              İki iş kolu, tek standart: <span className="text-[var(--tt-orange)]">kalite</span>.
            </h2>
          </div>
          <p className="text-base text-[var(--tt-charcoal)]/70 max-w-sm">
            Hırdavat ve geri dönüşüm — birbirini tamamlayan iki uzmanlık alanıyla
            yanınızdayız.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {SERVICES.map((s) => (
            <article
              key={s.key}
              data-testid={`service-card-${s.key}`}
              className="svc-card group rounded-3xl bg-white border border-black/5 overflow-hidden shadow-sm"
            >
              <div className="relative h-64 sm:h-72 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                <div
                  className="absolute top-4 left-4 px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-[0.18em] text-white"
                  style={{ background: s.accent }}
                >
                  {s.badge}
                </div>
                <h3 className="absolute bottom-4 left-5 right-5 font-display text-3xl sm:text-4xl text-white leading-tight">
                  {s.title}
                </h3>
              </div>
              <div className="p-7 sm:p-9">
                <p className="text-[var(--tt-charcoal)]/75 leading-relaxed">{s.desc}</p>
                {s.items.length > 0 && (
                  <ul className="mt-6 grid sm:grid-cols-2 gap-x-4 gap-y-3">
                    {s.items.map((it) => (
                      <li key={it} className="flex items-start gap-2 text-sm text-[var(--tt-charcoal)]/85">
                        <span
                          className="mt-1.5 w-1.5 h-1.5 rounded-full shrink-0"
                          style={{ background: s.accent }}
                        />
                        {it}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
